// Module
var code = `<condition ng-if="\$ctrl.propertyDefinition.type === \$ctrl.type"
           conditions="\$ctrl.conditions"
           property="\$ctrl.propertyDefinition.property">
  <div ng-repeat="property in \$ctrl.getCondition().properties">
    {{\$ctrl.getPropertyLabel(property)}}
  </div>

  <div class="btn-group">
    <button class="btn btn-default dropdown-toggle"
            data-toggle="dropdown">
      Add <span class="caret"></span>
    </button>
    <ul class="dropdown-menu">
      <li ng-repeat="pd in \$ctrl.getSupportedPropertyDefinitions()">
        <a ng-click="\$ctrl.addProperty(pd)">{{pd.label}}</a>
      </li>
    </ul>
  </div>

  <div class="inputs">
    <select
      ng-model="\$ctrl.predicate"
      ng-options="f as f | prettyEnum for f in \$ctrl.propertyDefinition.supportedPredicates"
      required>
    </select>

    <input ng-if="\$ctrl.predicate === 'BETWEEN'"
           type="number"
           ng-model="\$ctrl.model.param1"
           ng-change="\$ctrl.valueChanged()"
           min="0"
           max="\$ctrl.model.param2"
           required/>
    <input ng-if="\$ctrl.predicate === 'BETWEEN'"
           type="number"
           ng-model="\$ctrl.model.param2"
           ng-change="\$ctrl.valueChanged()"
           min="\$ctrl.model.param1"
           required/>

    <input ng-if="['EQUALS', 'EQUALS_OR_GREATER'].includes(\$ctrl.predicate)"
           type="number"
           ng-model="\$ctrl.model.param"
           ng-change="\$ctrl.valueChanged()"
           min="0"
           required/>
  </div>
</condition>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/conditions/number-condition.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;